import { IInquiry } from '../interfaces/inquiry.interface';
import { IIntercepted } from '../interfaces/intercept.interface';
import {
  IGetMessagesParams,
  IGetMessagesResponse,
  IPatchMessagesReadBody,
  IPostMessagesBody,
  IPostMessagesBodyForNewInquiry,
} from '../interfaces/message.interface';
import { get, patch, post } from '../utils/fetch';
import { IRecipient } from '../interfaces/user.interface';
import {
  MODE_MESSAGE_API_ERROR,
  MODE_MESSAGE_POST_API_ERROR,
  MODE_MESSAGE_READ_API_ERROR,
} from '../defines/mode';

export const MessageApi = {
  getMessages: async (
    threadId: string,
    inquiryId: string,
    params: IGetMessagesParams,
  ): Promise<{
    messages: IIntercepted<IGetMessagesResponse>;
    inquiry: IInquiry;
    recipients: IRecipient[];
  }> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_MESSAGE_API_ERROR) {
      throw new Error();
    }
    const url = `/api/messages/${threadId}/${inquiryId}`;
    return await get(url, params, 'getMessages');
  },

  postMessage: async (
    body: IPostMessagesBodyForNewInquiry | IPostMessagesBody,
  ): Promise<IGetMessagesResponse> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_MESSAGE_POST_API_ERROR) {
      throw new Error();
    }
    const url = '/api/messages';
    return await post(url, body, 'postMessage');
  },

  readMessages: async (
    threadId: string,
    inquiryId: string,
    body: IPatchMessagesReadBody,
  ): Promise<void> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_MESSAGE_READ_API_ERROR) {
      throw new Error();
    }
    const url = `/api/messages/read/${threadId}/${inquiryId}`;
    await patch(url, body, 'readMessages');
  },
};
